import React from 'react';
import './Hero.css';

const Hero = ({ setCurrentPage }) => {
  return (
    <section className="hero">
      <div className="hero-background">
        <div className="hero-overlay"></div>
      </div>

      <div className="hero-content">
        <div className="container">
          <div className="hero-text">
            <h1 className="hero-title slide-in-left">
              Advanced Security & Surveillance Solutions
            </h1>
            <p className="hero-subtitle slide-in-left">
              Professional video surveillance equipment and installation services for homes and businesses.
              Protect what matters most with cutting-edge IP cameras, NVR systems, and VoIP phone solutions.
            </p>

            <div className="hero-buttons slide-in-left">
              <button
                className="btn btn-primary hero-btn"
                onClick={() => setCurrentPage('services')}
              >
                View Services
              </button>
              <button
                className="btn btn-secondary hero-btn"
                onClick={() => setCurrentPage('products')}
              >
                Browse Products
              </button>
            </div>

            <div className="hero-features">
              <div className="hero-feature">
                <span className="feature-icon">📹</span>
                <span className="feature-text">500+ Systems Installed</span>
              </div>
              <div className="hero-feature">
                <span className="feature-icon">🛡️</span>
                <span className="feature-text">24/7 Technical Support</span>
              </div>
              <div className="hero-feature">
                <span className="feature-icon">🌐</span>
                <span className="feature-text">Remote Monitoring</span>
              </div>
            </div>

            {/* 🎓 Certificate Trust Badge */}
            <div className="certificate-badge-wrapper">
              <button
                className="certificate-badge"
                onClick={() => setCurrentPage('certificates')}
                aria-label="View Professional Certifications"
              >
                <span className="badge-icon">🎓</span>
                <div className="badge-content">
                  <span className="badge-text">Certified IT Professionals</span>
                  <span className="badge-subtext">View Credentials →</span>
                </div>
              </button>
            </div>
          </div>

          <div className="hero-image slide-in-right">
            <img
              src="https://media.istockphoto.com/id/673967530/photo/security-camera-setting.jpg?s=612x612&w=0&k=20&c=6-RwuEsTKpApknBoyq1xc41kfrsn2r_BUs6bamDpV6M="
              alt="Security Camera System"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;